<div class="detail-shell detail-shell--trade-map">
  @if (loading()) {
    <div class="trade-detail-skeleton" aria-busy="true" aria-label="กำลังโหลดข้อมูล"></div>
  } @else if (notFound() || !record()) {
    <div class="alert alert-warning d-flex flex-wrap align-items-center gap-2 m-3" role="alert">
      <span>ไม่พบรายการนี้</span>
      <a class="fw-semibold" [routerLink]="tradeBase">กลับไปรายการซื้อ-ขาย</a>
    </div>
  } @else if (record(); as current) {
    <section class="map-page">
      <div class="map-layout"
           [class.map-layout-collapsed]="sheetMode() === 'minimized'"
           [class.map-layout-expanded]="sheetMode() === 'expanded'">
        <aside class="map-information-area"
               [class.route-card-collapsed]="sheetMode() === 'minimized'"
               [class.route-card-expanded]="sheetMode() === 'expanded'"
               aria-label="ข้อมูลเส้นทางสินค้า">
          <section class="route-card map-place-panel"
                   [class.is-collapsed]="sheetMode() === 'minimized'"
                   [class.is-expanded]="sheetMode() === 'expanded'"
                   aria-label="ข้อมูลรายการสินค้า">

            <!-- Mobile sheet header: drag handle + view-mode actions -->
            @if (sheetMode() !== 'minimized') {
              <div class="mobile-sheet-header">
                <div class="mobile-sheet-handle-bar" (click)="toggleRouteCard()" role="button"
                     aria-label="ย่อหรือขยายรายละเอียด">
                  <span class="mobile-sheet-handle"></span>
                </div>
                <div class="mobile-sheet-actions">
                  <div class="mobile-view-switch" role="group" aria-label="เลือกมุมมอง">
                    <button type="button" class="mobile-switch-btn" [class.is-active]="viewMode() === 'map'"
                            (click)="setViewMode('map')">
                      <i class="bi bi-map"></i>
                      <span>แผนที่</span>
                    </button>
                    <button type="button" class="mobile-switch-btn" [class.is-active]="viewMode() === 'graph'"
                            (click)="setViewMode('graph')">
                      <i class="bi bi-diagram-3"></i>
                      <span>เส้นทางสินค้า</span>
                    </button>
                  </div>
                  <div class="mobile-sheet-mode-btns">
                    <button type="button" class="mobile-mode-btn" (click)="toggleRouteCard()"
                            [title]="sheetMode() === 'minimized' ? 'แสดงรายละเอียด' : 'ย่อดูแผนที่เต็มจอ'">
                      <i [class]="sheetMode() === 'minimized' ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                      <span>{{ sheetMode() === 'minimized' ? 'ดูรายละเอียด' : 'ย่อแผนที่' }}</span>
                    </button>
                    <button type="button" class="mobile-mode-btn mobile-mode-btn--expand" (click)="toggleExpand()"
                            [title]="sheetMode() === 'expanded' ? 'แบ่งหน้าจอ' : 'ขยายเต็มจอ'">
                      <i
                        [class]="sheetMode() === 'expanded' ? 'bi bi-arrows-angle-contract' : 'bi bi-arrows-angle-expand'"></i>
                      <span>{{ sheetMode() === 'expanded' ? 'แบ่งจอ' : 'เต็มจอ' }}</span>
                    </button>
                  </div>
                </div>
              </div>
            }

            <!-- Minimized mobile peek bar -->
            @if (sheetMode() === 'minimized') {
              <div class="mobile-peek-bar" (click)="toggleRouteCard()" role="button" aria-label="แตะเพื่อดูรายละเอียด">
                <div class="mobile-peek-info">
                  @if (current.productImageUrl) {
                    <img class="mobile-peek-thumb" [src]="current.productImageUrl"
                         [alt]="current.productName || 'สินค้า'">
                  } @else {
                    <div class="mobile-peek-thumb-placeholder">
                      <i class="bi bi-box-seam"></i>
                    </div>
                  }
                  <div class="mobile-peek-text">
                    <strong class="mobile-peek-title">{{ current.productName || 'ยังไม่ระบุสินค้า' }}</strong>
                    <div class="mobile-peek-badges">
                      <span class="mobile-peek-badge">
                        ทั้งหมด {{ formatQuantityWithUnit(current.quantity, current.unit || unit) }}
                      </span>
                    </div>
                  </div>
                </div>
                <button type="button" class="mobile-peek-expand-btn"
                        (click)="toggleRouteCard(); $event.stopPropagation()" aria-label="แสดงรายละเอียด">
                  <i class="bi bi-chevron-up"></i>
                  <span>รายละเอียด</span>
                </button>
              </div>
            }

            @if (sheetMode() !== 'minimized') {
              <div class="mobile-sheet-container">
                <!-- Product header: cover image on the LEFT, quantities on the RIGHT -->
                <div class="record-map-header-summary">
                  <div class="record-map-card-header">
                    @if (current.productImageUrl) {
                      <div class="record-map-image-wrap">
                        <img [src]="current.productImageUrl" [alt]="current.productName || 'สินค้า'">
                      </div>
                    } @else {
                      <div class="record-map-image-placeholder">
                        <img src="/assets/images/empty-basket.webp" alt="ยังไม่มีรูปสินค้า">
                      </div>
                    }
                  </div>

                  <div class="record-map-copy">
                    <strong class="h1 product-name">{{ current.productName || 'ยังไม่ระบุสินค้า' }}</strong>
                    <div class="record-map-detail-section record-map-record-section">
                      <div class="record-map-quantity-row">
                        <span>ทั้งหมด</span>
                        <strong class="record-map-quantity record-map-quantity--total">
                          {{ formatQuantityWithUnit(current.quantity, current.unit || unit) }}
                        </strong>
                      </div>
                      <div class="record-map-quantity-row">
                        <span>ขายแล้ว</span>
                        <strong class="record-map-quantity record-map-quantity--sold">
                          {{ formatQuantityWithUnit(soldQty(), current.unit || unit) }}
                        </strong>
                      </div>
                      <div class="record-map-quantity-row">
                        <span>คงเหลือ</span>
                        <strong class="record-map-quantity record-map-quantity--remaining">
                          {{ formatQuantityWithUnit(current.remainingQty, current.unit || unit) }}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="record-map-actions">

                  <div class="record-map-action-row">
                    @if (current.canEdit) {
                      <!--                      <button type="button" class="btn btn-sm record-map-mini-btn" (click)="editRecord()">-->
                        <!--                        <i class="bi bi-pencil" aria-hidden="true"></i> แก้ไข-->
                        <!--                      </button>-->
                      <label class="btn btn-sm record-map-mini-btn mb-0">
                        @if (uploading()) {
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        } @else {
                          <i class="bi bi-images" aria-hidden="true"></i>
                        }
                        เปลี่ยนรูป
                        <input type="file" class="d-none" accept="image/*" [disabled]="uploading()"
                               (change)="onCoverImageSelected($event)">
                      </label>
                    }
                    @if (current.canDelete) {
                      <button type="button" class="btn btn-sm record-map-mini-btn record-map-mini-btn--danger"
                              (click)="deleteRecord()">
                        <i class="bi bi-trash3" aria-hidden="true"></i> ลบ
                      </button>
                    }
                    <a class="record-map-back-link" [routerLink]="tradeBase">กลับไปรายการ</a>
                  </div>
                </div>

                <div class="map-panel-tabs" role="tablist" aria-label="ข้อมูลรายการ">
                  <button type="button" role="tab" [class.active]="activePanelTab() === 'details'"
                          [attr.aria-selected]="activePanelTab() === 'details'" (click)="selectPanelTab('details')">
                    รายละเอียด
                  </button>
                  <button type="button" role="tab" [class.active]="activePanelTab() === 'chain'"
                          [attr.aria-selected]="activePanelTab() === 'chain'" (click)="selectPanelTab('chain')">
                    ห่วงโซ่
                  </button>
                </div>

                @if (activePanelTab() === 'details') {
                  <div class="map-panel-content">
                    <div class="record-map-card">
                      <div class="record-map-scroll">
                        <div class="record-map-details">

                          <!-- ผลผลิต -->
                          <div class="record-map-detail-section">
                            <span class="record-map-section-title">
                              <i class="bi bi-basket2-fill" aria-hidden="true"></i> ผลผลิต
                            </span>
                            <div class="record-kind-row">
                              <span>ประเภทรายการ</span>
                              <strong>
                                <span [class]="'badge record-kind-badge ' + tradeKindBadgeClass(current.kind)">
                                  {{ tradeRecordLabel(current) }}
                                </span>
                                @if (current.export) {
                                  <span class="badge text-bg-danger ms-1">· สิ้นสุดห่วงโซ่ (ส่งออก)</span>
                                }
                              </strong>
                            </div>
                            <div>
                              <span>สินค้า</span><strong>{{ current.productName || '-' }}</strong>
                            </div>
                            @if (current.farmName) {
                              <div>
                                <span>ฟาร์ม</span><strong>{{ current.farmName }}</strong>
                              </div>
                            }
                            @if (current.farmLocation) {
                              <div>
                                <span>ที่ตั้งฟาร์ม</span><strong>{{ current.farmLocation }}</strong>
                              </div>
                            }
                            <div class="record-map-code-row">
                              <span>รหัสรายการ</span>
                              <strong>
                                <app-record-code [code]="current.recordCode" variant="text"/>
                              </strong>
                            </div>
                            <!-- ข้อมูลธุรกิจที่บันทึกไว้กับรายการ (snapshot) ไม่ใช่โปรไฟล์ปัจจุบัน -->
                            <div id="record-business-snapshot" class="record-business-snapshot">
                              <div class="record-business-snapshot-row">
                                <span>ธุรกิจ</span><strong>{{ current.businessTitle || '-' }}</strong>
                              </div>
                              @if (businessTypeTitles().length > 0) {
                                <div class="record-business-snapshot-types">
                                  @for (title of businessTypeTitles(); track title; let last = $last) {
                                    <span class="badge">{{ title }}</span>@if (!last) { <span class="snapshot-type-sep">·</span> }
                                  }
                                </div>
                              }
                              @if (current.businessTaxId) {
                                <div class="record-business-snapshot-row">
                                  <span>เลขประจำตัวผู้เสียภาษี</span>
                                  <strong>{{ current.businessTaxId }}</strong>
                                </div>
                              }
                              @if (current.businessAddress) {
                                <div class="record-business-snapshot-row">
                                  <span>ที่อยู่</span><strong>{{ current.businessAddress }}</strong>
                                </div>
                              }
                              @if (current.businessPhone) {
                                <div class="record-business-snapshot-row">
                                  <span>โทรศัพท์</span><strong>{{ current.businessPhone }}</strong>
                                </div>
                              }
                              <!--                              <p class="record-business-snapshot-hint">-->
                              <!--                                ข้อมูลธุรกิจ ณ เวลาที่บันทึกรายการ (ไม่เปลี่ยนตามการแก้ไขโปรไฟล์ในภายหลัง)-->
                              <!--                              </p>-->
                            </div>
                            @if (current.kind !== 'HARVEST' && current.sellerBusinessTitle) {
                              <div>
                                <span>ผู้ขาย</span><strong>{{ current.sellerBusinessTitle }}</strong>
                              </div>
                            }
                            @if (current.harvestDate) {
                              <div>
                                <span>วันที่เก็บเกี่ยว</span>
                                <strong>{{ current.harvestDate | thaidatetime: {showTime: false} }}</strong>
                              </div>
                            }
                            @if (current.truckNo) {
                              <div>
                                <span>ทะเบียนรถ</span>
                                <strong>
                                  {{ current.truckNo }}
                                  @if (current.truckSide) {
                                    ({{ current.truckSide === 'SELLER' ? 'รถของผู้ขาย' : 'รถของผู้ซื้อ' }})
                                  }
                                </strong>
                              </div>
                            }
                            @if (current.contactPhone) {
                              <div>
                                <span>เบอร์โทรคนขับ</span>
                                <strong>{{ current.contactPhone }}</strong>
                              </div>
                            }
                            <!-- Legacy SHIPMENT rows: read-only, no new record is written this way -->
                            @if (current.kind === 'SHIPMENT') {
                              @if (current.destination) {
                                <div>
                                  <span>ปลายทาง</span><strong>{{ current.destination }}</strong>
                                </div>
                              }
                              @if (current.containerNo) {
                                <div>
                                  <span>หมายเลขตู้คอนเทนเนอร์</span><strong>{{ current.containerNo }}</strong>
                                </div>
                              }
                              @if (current.sealNo) {
                                <div>
                                  <span>หมายเลขซีล</span><strong>{{ current.sealNo }}</strong>
                                </div>
                              }
                            }
                            @if (current.kind === 'TRANSFORM') {
                              <div>
                                <span>การแปรรูป</span>
                                <strong>
                                  ใช้ {{ formatQuantityWithUnit(current.inputQuantity, current.inputUnit || unit) }}
                                  {{ current.inputProductName }}
                                  → ได้ {{ formatQuantityWithUnit(current.quantity, current.unit || unit) }}
                                  {{ current.productName }}
                                </strong>
                              </div>
                              @if (current.transformNote) {
                                <div>
                                  <span>หมายเหตุการแปรรูป</span><strong>{{ current.transformNote }}</strong>
                                </div>
                              }
                            }
                            @if (current.packingNote) {
                              <div>
                                <span>หมายเหตุการบรรจุ</span><strong>{{ current.packingNote }}</strong>
                              </div>
                            }
                          </div>

                          <!-- ข้อมูลส่งออก — an exporter's record ends the chain -->
                          @if (current.export) {
                            <div class="record-map-detail-section">
                              <span class="record-map-section-title">
                                <i class="bi bi-airplane-fill" aria-hidden="true"></i> ข้อมูลส่งออก
                              </span>
                              <div>
                                <span>ด่านที่ส่งออก</span>
                                <strong>{{ current.exportCheckpointName || '-' }}</strong>
                              </div>
                              <div>
                                <span>ทะเบียนผู้ส่งออก</span>
                                <strong>{{ current.exporterRegistrationNo || '-' }}</strong>
                              </div>
                              @if (current.locationFromSeller) {
                                <div>
                                  <span>พิกัดบนแผนที่</span><strong>ใช้พิกัดของผู้ขาย</strong>
                                </div>
                              }
                              <!-- The truck is already in ผลผลิต above; container / seal / quality
                                   are only asked of an exporter that is also another business
                                   type, so they show only when filled in. -->
                              @if (current.containerNo) {
                                <div>
                                  <span>เลขตู้</span><strong>{{ current.containerNo }}</strong>
                                </div>
                              }
                              @if (current.sealNo) {
                                <div>
                                  <span>ซีล</span><strong>{{ current.sealNo }}</strong>
                                </div>
                              }
                              @if (current.qualityNote) {
                                <div>
                                  <span>หมายเหตุคุณภาพ</span><strong>{{ current.qualityNote }}</strong>
                                </div>
                              }
                            </div>
                          }

                          <!-- มาตรฐาน -->
                          @if (standards().length > 0) {
                            <div class="record-map-detail-section">
                              <span class="record-map-section-title">
                                <i class="bi bi-patch-check-fill" aria-hidden="true"></i> มาตรฐาน
                              </span>
                              @for (item of standards(); track item.certificateNo + '|' + $index; let first = $first) {
                                @if (!first) {
                                  <hr class="record-map-detail-divider">
                                }
                                <div><span>มาตรฐาน</span><strong>{{ item.standardCode || '—' }}</strong></div>
                                <div><span>ชื่อมาตรฐาน</span><strong>{{ item.standardName || '—' }}</strong></div>
                                <div><span>เลขที่ใบรับรอง</span><strong>{{ item.certificateNo || '—' }}</strong></div>
                              }
                            </div>
                          }

                          <!-- การซื้อขายต่อ (the old "พ่อค้าคนกลาง / ส่งออก" summary) -->
                          @if (downstream().length > 0) {
                            <div class="record-map-detail-section">
                              <span class="record-map-section-title">
                                <i class="bi bi-box-seam-fill" aria-hidden="true"></i> การซื้อขายต่อ
                              </span>
                              @for (item of downstream(); track item.recordId ?? $index) {
                                <details class="record-map-detail-list">
                                  <summary>
                                    <span>{{ item.roleLabel }}</span>
                                    <strong>
                                      <span>{{ item.businessTitle }}</span>
                                      <i class="bi bi-chevron-down" aria-hidden="true"></i>
                                    </strong>
                                  </summary>
                                  <div class="record-map-detail-list-content">
                                    <div class="record-kind-row">
                                      <span>ประเภทรายการ</span>
                                      <strong>
                                        <span [class]="'badge record-kind-badge ' + tradeKindBadgeClass(item.kind)">
                                          {{ tradeRecordLabel(item) }}
                                        </span>
                                      </strong>
                                    </div>
                                    <div>
                                      <span>ปริมาณ</span>
                                      <strong>{{ formatQuantityWithUnit(item.quantity, item.unit || unit) }}</strong>
                                    </div>
                                    <div><span>วันที่</span><strong>{{ item.recordedAt | thaidatetime }}</strong></div>
                                    @if (item.productName) {
                                      <div><span>สินค้า</span><strong>{{ item.productName }}</strong></div>
                                    }
                                    @if (item.truckNo) {
                                      <div><span>ทะเบียนรถ</span><strong>{{ item.truckNo }}</strong></div>
                                    }
                                    @if (item.destination) {
                                      <div><span>ปลายทาง</span><strong>{{ item.destination }}</strong></div>
                                    }
                                    @if (item.recordId != null) {
                                      <div>
                                        <span></span>
                                        <strong>
                                          <a class="record-map-detail-link" [routerLink]="[tradeBase, item.recordId]">
                                            ดูรายการปลายทาง
                                          </a>
                                        </strong>
                                      </div>
                                    }
                                  </div>
                                </details>
                              }
                            </div>
                          } @else if (!current.export) {
                            <!-- an export ends the chain, so "nothing sold on yet" is not a state it can be in -->
                            <div class="record-map-empty-detail">
                              <span class="record-map-section-title">
                                <i class="bi bi-box-seam-fill" aria-hidden="true"></i> การซื้อขายต่อ
                              </span>
                              <span>ยังไม่มีการซื้อขายต่อจากรายการนี้</span>
                            </div>
                          }

                          <!-- วันที่บันทึก -->
                          <div class="record-map-detail-section">
                            <span class="record-map-section-title">
                              <i class="bi bi-calendar3" aria-hidden="true"></i> วันที่บันทึก
                            </span>
                            <div><span>บันทึกเมื่อ</span><strong>{{ current.recordedAt | thaidatetime }}</strong></div>
                            @if (current.updatedAt) {
                              <div><span>แก้ไขล่าสุด</span><strong>{{ current.updatedAt | thaidatetime }}</strong></div>
                            }
                          </div>

                          <!-- ประวัติการแก้ไข (audit trail) -->
<!--                          @if (history().length > 0) {-->
<!--                            <div class="record-map-detail-section record-history" aria-label="ประวัติการแก้ไข">-->
<!--                              <span class="record-map-section-title">-->
<!--                                <i class="bi bi-clock-history" aria-hidden="true"></i> ประวัติการแก้ไข-->
<!--                              </span>-->
<!--                              <ol class="record-history-list">-->
<!--                                @for (entry of history(); track entry.id) {-->
<!--                                  <li class="record-history-entry">-->
<!--                                    <div class="record-history-head">-->
<!--                                      <span-->
<!--                                        [class]="'badge ' + (auditActionBadges[entry.action ?? ''] ?? 'text-bg-secondary')">-->
<!--                                        {{ auditActionLabels[entry.action ?? ''] ?? entry.action }}-->
<!--                                      </span>-->
<!--                                      <span-->
<!--                                        class="fw-semibold">{{ entry.actorName || ('ผู้ใช้ #' + entry.userId) }}</span>-->
<!--                                      <span class="text-secondary small">{{ entry.createdDate | thaidatetime }}</span>-->
<!--                                    </div>-->
<!--                                    @if (entry.action === 'UPDATE' && entry.changes?.length) {-->
<!--                                      <ul class="record-history-changes">-->
<!--                                        @for (change of entry.changes; track change.field) {-->
<!--                                          <li>-->
<!--                                            <span class="record-history-field">{{ change.label || change.field }}</span>-->
<!--                                            <span class="record-history-before">{{ change.before || '—' }}</span>-->
<!--                                            <i class="bi bi-arrow-right" aria-hidden="true"></i>-->
<!--                                            <span class="record-history-after">{{ change.after || '—' }}</span>-->
<!--                                          </li>-->
<!--                                        }-->
<!--                                      </ul>-->
<!--                                    } @else if (entry.action === 'UPDATE') {-->
<!--                                      <div class="small text-secondary">บันทึกโดยไม่มีข้อมูลเปลี่ยนแปลง</div>-->
<!--                                    }-->
<!--                                  </li>-->
<!--                                }-->
<!--                              </ol>-->
<!--                            </div>-->
<!--                          }-->
                        </div>
                      </div>
                    </div>
                  </div>
                } @else {
                  <div class="map-panel-content">
                    <div class="record-map-chain-section">
                      <!-- The whole journey as one tree, flow order: origin lots down to the exporter and its ด่าน. -->
                      <app-trade-chain-tree [nodes]="journeyTree()" [pins]="pinNumbers()"></app-trade-chain-tree>
                    </div>
                  </div>
                }
              </div>
            }
          </section>
        </aside>

        <div class="map-cell">
          @if (viewMode() === 'map') {
            <div #mapContainer class="map-canvas" aria-label="แผนที่เส้นทางการซื้อ-ขายในประเทศไทย"></div>

            @if (businessesWithoutLocation().length > 0) {
              <div class="map-no-coordinates">
                @if (!hasCoordinates()) {
                  <strong>ไม่มีพิกัด</strong>
                }
                <span>ยังไม่มีพิกัดของ {{ businessesWithoutLocation().join(', ') }}</span>
                @if (canSetMissingLocation()) {
                  <a routerLink="/profile/business">ตั้งพิกัดที่ข้อมูลธุรกิจ</a>
                }
              </div>
            }
          } @else {
            <app-trade-journey-graph [chain]="chain()" [showObservations]="showObservations()"
                                     (recordSelected)="openRecord($event)"/>
          }

          <div class="map-floating-controls">
            <div class="map-view-switch" role="group" aria-label="เลือกมุมมอง">
              <button type="button" class="map-view-switch-btn" [class.is-active]="viewMode() === 'map'"
                      (click)="setViewMode('map')" [attr.aria-pressed]="viewMode() === 'map'">
                <i class="bi bi-map"></i>
                <span>แผนที่</span>
              </button>
              <button type="button" class="map-view-switch-btn" [class.is-active]="viewMode() === 'graph'"
                      (click)="setViewMode('graph')" [attr.aria-pressed]="viewMode() === 'graph'">
                <i class="bi bi-diagram-3"></i>
                <span>เส้นทางสินค้า</span>
              </button>
            </div>
            <button type="button" class="map-float-btn map-float-btn--toggle" (click)="toggleRouteCard()"
                    [attr.aria-label]="sheetMode() === 'minimized' ? 'แสดงรายละเอียด' : 'ดูเต็มจอ'">
              <i [class]="sheetMode() === 'minimized' ? 'bi bi-card-text' : 'bi bi-arrows-fullscreen'"></i>
              <span>{{ sheetMode() === 'minimized' ? 'แสดงรายละเอียด' : 'ดูเต็มจอ' }}</span>
            </button>
            @if (viewMode() === 'map') {
              <button type="button" class="map-float-btn map-float-btn--recenter" (click)="recenterMap()"
                      title="จัดตำแหน่งเส้นทางบนแผนที่" aria-label="จัดตำแหน่งเส้นทางบนแผนที่">
                <i class="bi bi-geo-alt-fill"></i>
              </button>
            }
          </div>
        </div>
      </div>
      @if (viewMode() === 'map') {
        <p class="map-note">แผนที่ข้อมูล © OpenStreetMap</p>
      } @else {
        <p class="map-note">คลิกกล่องเพื่อเปิดรายการนั้น</p>
      }
    </section>
  }
</div>
